/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Map ZoomOut Icon component.
 */
export const MapZoomOutIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='MapZoomOutIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M5 13h14.15'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap='round' />
      </svg>
    )} />
  );
};
